<button
  type="button"
  class="tab"
  [class.tab--left]="edge === 'left'"
  [attr.aria-label]="pendingCount ? 'Open Buddy — ' + pendingCount + ' waiting' : 'Open Buddy'"
  (click)="opened.emit()"
>
  <app-bb-mascot [state]="bbState" [stage]="stage" [size]="22" [decorative]="true"></app-bb-mascot>

  <span class="tab__bar" aria-hidden="true">
    <span class="tab__bar-fill" [style.height.%]="xpPct"></span>
  </span>

  <span class="tab__count" *ngIf="pendingCount > 0" aria-hidden="true">{{ pendingCount }}</span>
</button>
